import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { ArtisticFilterVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { Text } from 'blaze-ui/Text/Text'
import { ArtisticFilters } from 'common/Prose/nodeViews/Image/components/ImageVariant/ArtisticFilters'
import { useImageStore } from 'stores/ImageStore'

export const ArtisticFilterVariant = (props: ArtisticFilterVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()

  return (
    <ImageVariant {...props}>
      <Text variant="label">Change artistic filter</Text>
      <ArtisticFilters
        selectedFilter={variant.qualifier}
        url={imageStore.attrs.src}
        onFilter={(image, filter) => {
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'artistic_filter', qualifier: filter })
        }}
      />
    </ImageVariant>
  )
}
